import PropTypes from 'prop-types'
import React, { Fragment } from 'react'
import { withRouter } from 'react-router'
import { getSearchTerm } from 'Utils'
import { SearchForm } from 'Blocks'
import { Filters, CategoryHeader } from '../components'
import ProductList from '../../ProductList'

const Large = props => {
  const { data } = props
  return (
    <Fragment>
      <CategoryHeader {...props} {...data} />
      <Filters {...props} {...data} />
      <ProductList {...props} {...data} />
    </Fragment>
  )
}

Large.propTypes = {
  data: PropTypes.any,
  location: PropTypes.any
}

export default withRouter(Large)
